angular.module('unica_invitation_room.invitation_room_controllers')

.controller('InvitationRoomListController', function(
	CONFIG,
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	InvitationRoomListService, InvitationRoomDeleteService,
	InvitationRoomEditService, RoomListService
) {
	$scope.invitationRooms = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationType = null;
	$scope.$on('event_loaded', function() {
		$scope.notificationType = $rootScope.eventData.notification_type;
	});


	$scope.loadHotelRoomsRecap = function()
	{
		$scope.showLoader();
		RoomListService
			.getListGrouped( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.hotelRooms = data;
				}
			});
	};
	$scope.loadHotelRoomsRecap();






	$scope.loadInvitationRooms = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		InvitationRoomListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationRooms = $scope.invitationRooms.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadInvitationRooms();

	$scope.notifyInvitationRooms = function() {
		if ( !$scope.notificationType ) {
			$scope.showErrorMsg(
				'Per poter inviare le notifiche è necessario impostare il tipo di notifica nella pagina di modifica evento'
			);
		} else {
			$confirm({
				title: 'Sei sicuro di voler procedere con l\'invio delle notifiche?',
				text: 'Confermi l\'invio delle notifiche (' + $scope.notificationType + ') a tutti gli utenti assegnati?'
			}).then(function() {

				$scope.showLoader();
				InvitationRoomEditService
					.sendNotifications( { event_id: $scope.event_id }  )
					.then(function(data) {
						$scope.hideLoader();

						if ( data ) {
						// 	angular.forEach($scope.invitationTransfersEvent, function(invitationTransferEvent, key) {
						// 		if ( invitationTransferEvent.id === invitationTransferEventId ) {
						// 			$scope.invitationTransfersEvent.splice(key, 1);
						// 		}
						// 	});
						//
						// 	$scope.loadTransferEventsRecap();

							// I non raggiungibili sono quelli che non hanno numero impostato o non hanno l'app
							$scope.showSuccessMsg(
								'Invio di ' + data.notifiche +  ' notifiche ' + data.type + ' avviato con successo!' +
									' (' + data.not_defined + ' non raggiungibili)', ''
							);
						}

					});

			}, function() {
				// Cancel
			});
		}
	};

	$scope.clearInvitationRooms = function() {

		$confirm({
			title: 'Sei sicuro di voler eliminare tutte le Stanze Assegnate?',
			text: 'Confermi la cancellazione di tutte le Stanze Assegnate?'
		}).then(function() {

			$scope.showLoader();
			InvitationRoomDeleteService
				.erase( $scope.event_id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.invitationRooms = [];

						$scope.loadHotelRoomsRecap();

						$scope.showSuccessMsg('Stanze Assegnate eliminate con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.deleteInvitationRoom = function(invitationRoomId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la Stanza Assegnata?',
			text: 'Confermi la cancellazione della Stanza Assegnata?'
		}).then(function() {

			$scope.showLoader();
			InvitationRoomDeleteService
				.delete( invitationRoomId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.invitationRooms, function(invitationRoom, key) {
							if ( invitationRoom.id === invitationRoomId ) {
								$scope.invitationRooms.splice(key, 1);
							}
						});

						$scope.loadHotelRoomsRecap();

						$scope.showSuccessMsg('Stanza Assegnata eliminata con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});

	};



	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingInvitations = false;
	$scope.searchInvitationRoom = function(search) {
		$scope.loadingInvitations = true;
		InvitationRoomListService
			.search( $scope.event_id, search )
			.then(function(data) {
				$scope.loadingInvitations = false;
				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.invitationRooms = data;
					return data;
				} else {
					$scope.invitationRooms = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};

	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.invitationRooms = [];
		}
	});


	$scope.downloadExportRoomEvent = false;
	$scope.exportRoomEventUrl      = '';

	$scope.prepareExportRoomEventUrl = function() {
		$scope.showLoader();
		InvitationRoomListService
			.exportRoomEvent( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportRoomEvent = true;
					$scope.exportRoomEventUrl      = url;
				}
			});
	};

});